import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, getAuthorize } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Authorize = Loadable({
    loader: () => import('./Authorize'),
    render(loaded, props) {
      const Component = connect((state) => ({
        oauthAuthorizeState: state.oauthAuthorizeState,
        siteConfig: state.siteConfig
      }), {
        init,
        getAuthorize
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/authorize`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Authorize {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
